import React, { Component } from "react";

class LoanGroupContainerV2 extends Component {
    constructor(props) {
        super(props);  
        this.state = {
            offsetWidth : 0,
        }
    }
    // updateDimensions = () => {
    //     var width = document.getElementById('acorn-body');
    //     this.setState({ deviceWidth: width.offsetWidth });   
    // };
    // componentDidMount() {
    //     // window.addEventListener('resize', this.updateDimensions);
    //     var that = this;
    //     window.addEventListener("resize", (ev) => {
    //         var width = document.getElementById('acorn-body');
    //         that.setState({ deviceWidth : width.offsetWidth});
    //     });
    // }
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.updateDimensions);
    // }
    render() {
        return (
            <span>
                <div className={`sortable-tableV2 no-top-margin ${this.props.deviceWidth>1024?"plmp-desktop":'plmp-mobile'}`}> 
                    {this.props.lenders}
                </div>
                <div id="marketplace-ad"></div>
            </span>
        );
    }
}

export default LoanGroupContainerV2;



// WEBPACK FOOTER //
// ./src/LoanGroupContainerV2.js